import React from 'react'
import { Avatar, Badge, Box, Grid, GridItem } from '@chakra-ui/react'
import { handleSpecificBackgroundCategory } from '../../../covers'

const BackgroundImage = ({
  item,
  accentColor,
  fontFamily,
  skin,
  greatestCashback
}) => {
  return (
    <Box
      w='100%'
      h='auto'
      borderTopRadius='lg'
      p='1rem'
      pos='relative'
      bgImage={handleSpecificBackgroundCategory(item.raw_category)}
      bgPosition='center'
      bgSize='cover'
      _before={{
        content: '""',
        bgColor: `brand.overlayBG`,
        bgSize: 'cover',
        pos: 'absolute',
        borderTopRadius: 'lg',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        opacity: 0.7
      }}
    >
      <Grid w='100%' templateColumns='repeat(12, 2fr)' mt='1rem'>
        <GridItem
          colSpan={[6, 6, 6, 6]}
          display='flex'
          alignItems='center'
          justifyContent='flex-start'
        >
          <Avatar
            shadow='xl'
            showBorder
            size='xl'
            borderColor='brand.avatarBorder'
            bg='white'
            borderWidth='4px'
            src={item.media}
            fontFamily={fontFamily}
          />
        </GridItem>
        <GridItem
          colSpan={[6, 6, 6, 6]}
          display='flex'
          alignItems='flex-end'
          justifyContent='flex-end'
        >
          <Box
            w='100%'
            display='flex'
            alignItems='flex-end'
            justifyContent='flex-end'
            flexDirection='row'
            zIndex={0}
            textColor={skin === 'COPPEL' ?? 'brand.error'}
          >
            <Badge
              fontSize={skin === 'COPPEL' ? '10px' : '0.8em'}
              bg={
                skin === 'COPPEL'
                  ? 'brand.white'
                  : skin === 'UNIQ'
                  ? '#fff'
                  : skin === 'LIVERPOOL'
                  ? '#fff'
                  : skin === 'SUBURBIA'
                  ? '#fff'
                  :skin === 'ALBO'
                  ? '#F8644F'
                  : accentColor
              }
              color={
                skin === 'COPPEL'
                  ? 'brand.secondary'
                  : skin === 'UNIQ'
                  ? '#1E3DBC'
                  : skin === 'LIVERPOOL'
                  ? '#e10098'
                  : skin === 'SUBURBIA'
                  ? '#552166'
                  : skin === 'ALBO'
                  ? '#FFF'
                  : 'white'
              }
              variant='solid'
              borderRadius='6px'
              p={skin === 'COPPEL' ? '4px 10px' : '0rem 0.4rem'}
              fontFamily={fontFamily}
              fontWeight='600'
            >
              {greatestCashback
                ? `Hasta ${greatestCashback}% ${renderSwitch(skin)}`
                : renderMessage(item, skin)}
            </Badge>
          </Box>
        </GridItem>
      </Grid>
    </Box>
  )
}

const renderMessage = (item, skin) => {
  if (
    [
      '653028b72b87c830742c389c',
      '65302bf32b87c830742c38fe',
      '65302c2f2b87c830742c390e',
      '65302ef82b87c830742c3953',
      '65302ca72b87c830742c3920',
      '65302f3f2b87c830742c396a',
      '65302f5e2b87c830742c397a',
      '65302f7b2b87c830742c398a'
    ].includes(item.offerId)
  ) {
    return `Hasta ${item.dv_cashback} ${renderSwitch(skin)}`
  } else {
    return `${item.dv_cashback} ${renderSwitch(skin)}`
  }
}

const renderSwitch = (skin) => {
  switch (skin) {
    case 'COPPEL':
      return 'de dinero electrónico'
    case 'INVEX':
      return 'de bonificación'
    case 'SUBURBIA':
      return 'de reembolso'
    case 'ALBO':
        return 'de beneficio'
    default:
      return 'cashback'
  }
}

export default BackgroundImage
